import { render, staticRenderFns } from "./xeIodCardSetting.vue?vue&type=template&id=6fa6ae82"
import script from "./xeIodCardSetting.vue?vue&type=script&lang=js"
export * from "./xeIodCardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports